import * as SegmentTab from './SegmentTab/SegmentTab.css';
import * as SegmentTabs from './SegmentTabs/SegmentTabs.css';
export default {
    SegmentTab,
    SegmentTabs
};
